import React, {useEffect, useState} from 'react';
import Datas from '../data/footer/footer2.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import BackToTop from './common/BackToTop';
import { Styles } from "./styles/footerTwo.js";
import axios from 'axios';

function FooterTwo() {

    const [footers, setFooters] = useState([]);
    useEffect(() => {
        const getFooters = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/footers/find-all`).then((response) => setFooters(response.data))
            .catch((error) => console.error(error));
        }
        getFooters();
    },[])
// console.log(footers);
    return (
        <Styles>
            {/* Footer Two */}
            <footer className="footer2" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/vd-bg.jpg` }}>
                <Container>
                    <Row>
                    {
                        footers !== null && footers.length > 0 ? footers.map((data, i) => (
                            <React.Fragment key={i}>
                                <Col md="6">
                                    <div className="footer-logo-info">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt="footer-logo" className="img-fluid" />
                                        <ul className="list-unstyled">
                                            <li><i className="las la-map-marker"></i>{data.footerAddress}</li>
                                            <li onClick={() => window.location = `mailto:${data.footerEmail}?subject=Email From Website&body=Dear Concerned, %0A <Write your details here>`}><i className="las la-envelope"></i>{data.footerEmail}</li>
                                            <li><i className="las la-phone"></i>{data.footerPhone}</li>
                                            <li><i className="las la-globe"></i>{data.footerLocations}</li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="f-links">
                                        <h5>Focus Area</h5>
                                        <Row>                                  
                                            <Col>
                                            {
                                                data.focusArea !== null && data.focusArea.length > 0 ? data.focusArea.map((focus, i) => (
                                                    <ul className="list-unstyled" key={i}>
                                                        <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>{focus}</Link></li>
                                                       
                                                    </ul>
                                                )): "No focus area available"
                                            }
                                            {/* <ul className="list-unstyled">
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>Sydney Metro</Link></li>
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>Sydney CBD</Link></li>
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>Northern Beaches</Link></li>
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>Parramatta</Link></li>
                                            </ul> */}
                                            </Col>
                                            {/* <Col>
                                            <ul className="list-unstyled">
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>Zetland Region</Link></li>
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>Meadow Bank Region</Link></li>
                                                <li><Link to={process.env.PUBLIC_URL + "/"}><i className="las la-angle-right"></i>North Shore</Link></li>
                                            </ul>
                                            </Col> */}
                                        </Row>
                                        
                                    </div>
                                </Col>   
                            </React.Fragment>
                        )): "No footers"
                    }
                    </Row>
                </Container>

                {/* Back To Top  */}
                <BackToTop />
            </footer>
        </Styles>
    );
}

export default FooterTwo
